"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TAB_OPTIONS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdFormskeleton = _interopRequireDefault(require("@bit/gerenciatd.formskeleton.form-skeleton"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));
var _gerenciatdUnifiedcomponents2 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _functionsUtils = require("./functionsUtils");
var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.metrics");
var _AtencionFormulario = _interopRequireDefault(require("./AtencionFormulario"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
require("./ModalAtencionEmp.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const TAB_OPTIONS = {
  LLAMADA: 'te-llamamos',
  VISITA: 'solicitar-visita',
  OK_C2C: 'ok_c2c',
  OK_VISITA: 'ok_visita',
  KO: 'ko',
  WAITING: 'waiting'
};
exports.TAB_OPTIONS = TAB_OPTIONS;
const COMPONENT_NAME = 'Modal Atencion Emp';

/**
 * Variable con el context para la sonda
 */
const contextEmp = (0, _functionsUtils._createSondaContext)('empresas');
const ModalAtencionEmp = props => {
  const {
    Modal,
    SvgIconLoader,
    campaign,
    product,
    tabsOptions,
    taggingInfo,
    visitaDobleColumn
  } = props;
  const {
    userType
  } = (0, _reactRedux.useSelector)(state => state.context.data);
  const [tabOption, setTabOption] = (0, _react.useState)(tabsOptions.tabOptionPreChecked || Object.keys(tabsOptions.tabsAvaliable)[0]);
  const [formSelected, setFormSelected] = (0, _react.useState)(tabsOptions.tabOptionPreChecked || Object.keys(tabsOptions.tabsAvaliable)[0]);
  // const [tabOption, setTabOption] = useState(TAB_OPTIONS.WAITING);
  // const [tabOption, setTabOption] = useState(TAB_OPTIONS.OK_C2C);
  // const [tabOption, setTabOption] = useState(TAB_OPTIONS.OK_VISITA);
  // const [tabOption, setTabOption] = useState(TAB_OPTIONS.KO);
  const [iframeReady, setIframeReady] = (0, _react.useState)(false);
  const [waiting, setWaiting] = (0, _react.useState)(false);
  const [options, setOptions] = (0, _react.useState)((0, _functionsUtils._ChooseSendOptions)(tabsOptions.tabsAvaliable));
  const setCampaign = (campaign, data) => {
    setDatos(_objectSpread(_objectSpread(_objectSpread({}, data), datos), {}, {
      campania: campaign
    }));
  };
  const [datos, setDatos] = (0, _react.useState)();
  const datosUsuario = (0, _functionsUtils.datosUsuarioFromSession)();
  (0, _react.useEffect)(() => {
    const data = {
      nombre: datosUsuario && datosUsuario.nombre || 'N/A',
      apellidos: 'N/A',
      cif: datosUsuario && datosUsuario.docNumber || '',
      telefono: datosUsuario && datosUsuario.telefono || '',
      email: datosUsuario && datosUsuario.email || 'no.aplica@noaplica.com',
      modalidad: product,
      observaciones: '',
      provincia: '',
      tes: options[formSelected] && options[formSelected].tes || '',
      tipo: options[formSelected] && options[formSelected].tipoTes || '',
      campania: campaign || window && window.scxValue || '',
      numeroEmpleados: 'No aplica'
    };
    if (data.campania === '') {
      (0, _functionsUtils.requestCampaignToScxBackend)(setCampaign, data);
    } else {
      setDatos(data);
    }
  }, []);
  (0, _react.useEffect)(() => {
    window.addEventListener('message', manageMessageIframe);
    return () => {
      window.removeEventListener('message', manageMessageIframe);
    };
  }, [tabOption]);
  const finalTaggingInfo = _objectSpread(_objectSpread({
    componentName: COMPONENT_NAME
  }, taggingInfo), {}, {
    componentProduct: product,
    componentContent: tabOption,
    componentVariation: campaign ? `${options[formSelected].destino}_${campaign}` : options[formSelected].destino
  });
  if (tabOption == TAB_OPTIONS.LLAMADA || tabOption == TAB_OPTIONS.VISITA) {
    finalTaggingInfo.componentVariation = campaign ? `${options[formSelected].destino}_${campaign}` : options[formSelected].destino;
  }
  const isClient = userType !== undefined && userType !== '' || window.location.href.includes('col10mgmt') || window.location.href.includes('127.0.0.1');
  const printHead = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "head__wrapper",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
          componentContent: 'cerrar'
        }),
        onClick: Modal.hide,
        className: "closeButton noButton",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
          id: "Cerrar",
          color: "white",
          kind: "M",
          size: 16,
          segment: "emp"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        className: "head__text",
        text: "Te asesoramos",
        align: _gerenciatdUnifiedcomponents2.ALIGN.LEFT,
        size: _gerenciatdUnifiedcomponents2.SIZE.TITLE4,
        color: _gerenciatdUnifiedcomponents2.COLOR.WHITE,
        fontType: _gerenciatdUnifiedcomponents2.FONT_TYPE.REGULAR,
        kind: _gerenciatdUnifiedcomponents2.KIND_TEXT.SPAN,
        segment: _gerenciatdUnifiedcomponents2.SEGMENT.EMP
      })]
    });
  };

  /**
   * Pinta el selector de tabs
   * @param {*} tabsAvaliable Configuracion para pintar las tabs
   * @returns
   */
  const printTabSelector = (tabsAvaliable, campaign) => {
    const tabs = Object.keys(tabsAvaliable).map(element => {
      return {
        icon: tabsAvaliable[element].icon,
        text: tabsAvaliable[element].text,
        value: element
      };
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.default, {
      tabs: tabs,
      onclick: changeTab,
      SvgIconLoader: SvgIconLoader,
      selected: tabOption,
      options: options,
      taggingInfo: finalTaggingInfo,
      campaign: campaign
    });
  };
  const changeTab = tabOptionSelected => {
    if (tabOptionSelected !== tabOption) {
      setTabOption(tabOptionSelected);
      setFormSelected(tabOptionSelected);
      setDatos(_objectSpread(_objectSpread({}, datos), {}, {
        tes: options[tabOptionSelected].tes,
        tipo: options[tabOptionSelected].tipoTes
      }));
      // Se cambia para que el taggingInfo se mantenga consistente en funcion del formulario enviado
      if (tabOptionSelected == TAB_OPTIONS.LLAMADA || tabOptionSelected == TAB_OPTIONS.VISITA) {
        finalTaggingInfo.componentVariation = campaign ? `${options[tabOptionSelected].destino}_${campaign}` : options[tabOptionSelected].destino;
        finalTaggingInfo.componentContent = tabOption;
      }
    }
  };

  /**
   * Metodo que gestiona la comunicacion con el iframe
   */
  const manageMessageIframe = e => {
    const sonda = new _gerenciatdUtils.default({
      processName: 'manageMessageIframe',
      context: contextEmp,
      filePath: 'ModalAtencionEmp'
    });
    const taggingInfoEvent = _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
      event: 'cms-component',
      eventType: 'form',
      componentContent: `formulario-enviado_${tabOption}`
    });
    switch (e.data.info) {
      case 'Form_loaded':
        setIframeReady(true);
        break;
      case 'KO':
        taggingInfoEvent.componentContent = `formulario-ko_${tabOption}`;
        taggingInfoEvent.componentVariation = finalTaggingInfo.componentVariation;
        (0, _gerenciatdUtils2.sendCMSEvent)(taggingInfoEvent);
        sonda.severalMessage({
          info: 'Formulario TES no envio la información'
        });
        setWaiting(false);
        setTabOption('ko');
        break;
      case 'OK':
        taggingInfoEvent.componentContent = `formulario-enviado_${tabOption}`;
        taggingInfoEvent.componentVariation = finalTaggingInfo.componentVariation;
        (0, _gerenciatdUtils2.sendCMSEvent)(taggingInfoEvent);
        setWaiting(false);
        tabOption === 'c2c' ? setTabOption('ok_c2c') : setTabOption('ok_visita');
        break;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ModalAtencionEmp",
    children: [printHead(), (0, _functionsUtils.printIframe)(finalTaggingInfo), (tabOption === TAB_OPTIONS.LLAMADA || tabOption === TAB_OPTIONS.VISITA) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [waiting && (0, _functionsUtils.printWaiting)(), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ModalAtencionScrollWrapped",
        children: [printTabSelector(tabsOptions.tabsAvaliable, campaign), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdFormskeleton.default, {
          name: "FormC2C",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AtencionFormulario.default, {
            taggingInfo: finalTaggingInfo,
            destino: options[formSelected] && options[formSelected].destino,
            tabOption: tabOption,
            setDatos: setDatos,
            datos: datos,
            iframeReady: iframeReady,
            config: tabsOptions.tabsAvaliable[tabOption],
            isClient: isClient,
            datosUsuario: datosUsuario,
            SvgIconLoader: SvgIconLoader,
            visitaDobleColumn: visitaDobleColumn,
            setWaiting: setWaiting
          })
        })]
      })]
    }), tabOption === TAB_OPTIONS.KO && (0, _functionsUtils.printKO)(SvgIconLoader, Modal, finalTaggingInfo), tabOption === TAB_OPTIONS.OK_C2C && (0, _functionsUtils.printOKC2C)(SvgIconLoader, Modal, finalTaggingInfo), tabOption === TAB_OPTIONS.OK_VISITA && (0, _functionsUtils.printOKVisita)(SvgIconLoader, Modal, finalTaggingInfo)]
  });
};
ModalAtencionEmp.propTypes = {
  Modal: _propTypes.default.func.isRequired,
  SvgIconLoader: _propTypes.default.func.isRequired,
  taggingInfo: _propTypes.default.arrayOf([_propTypes.default.string]).isRequired,
  campaign: _propTypes.default.string,
  product: _propTypes.default.string,
  tabsOptions: _propTypes.default.shape({
    tabOptionPreChecked: _propTypes.default.string,
    tabsAvaliable: _propTypes.default.arrayOf(_propTypes.default.shape({
      porcentaje: _propTypes.default.number.isRequired,
      destino: _propTypes.default.oneOf([_functionsUtils.DESTINO]).isRequired,
      tes: _propTypes.default.oneOf([_functionsUtils.TESVALUES]).isRequired,
      tipoTes: _propTypes.default.oneOf([_functionsUtils.TIPOS_ENCAMINAMIENTO]).isRequired
    }))
  }).isRequired,
  visitaDobleColumn: _propTypes.default.bool
};
ModalAtencionEmp.defaultProps = {
  visitaDobleColumn: false,
  tabsOptions: {
    tabOptionPreChecked: 'c2c',
    tabsAvaliable: {
      c2c: {
        text: 'Por teléfono',
        icon: 'Fijo',
        encaminamiento: [{
          porcentaje: 12,
          destino: _functionsUtils.DESTINO.INSIDESALES,
          tes: 'SI',
          tipoTes: 'ME_C'
        }, {
          porcentaje: 88,
          destino: _functionsUtils.DESTINO.GEVICO,
          tes: 'SI',
          tipoTes: 'SVC_C'
        }]
      },
      visita: {
        text: 'En persona prueba',
        icon: 'VisitaComercial',
        encaminamiento: [{
          porcentaje: 12,
          destino: _functionsUtils.DESTINO.INSIDESALES,
          tes: 'SI',
          tipoTes: 'ME_B'
        }, {
          porcentaje: 88,
          destino: _functionsUtils.DESTINO.GEVICO,
          tes: 'SI',
          tipoTes: 'SVC_B'
        }]
      }
    }
  }
};
var _default = ModalAtencionEmp;
exports.default = _default;

//# sourceMappingURL=index.js.map